import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { deleteArtist, getArtists } from '../../store/actions/artist/artist.action';
import Artists from '../../components/Artist/Artists';
import PageLoader from '../../components/Common/PageLoader';

const PiecesInstrumentContainer = () => {
  // Redux hooks
  const dispatch = useDispatch();

  // Redux state
  const artists = useSelector((state) => state.artist.list);
  const isFetching = useSelector((state) => state.artist.isFetching);
  const categories = useSelector((state) => state.auth.categories);

  // Local state
  const [mode, setMode] = useState('');
  const [accessDenied, setAccessDenied] = useState(false);

  // Set access based on categories
  const setAccess = useCallback(() => {
    try {
      const artistCategory = categories.find((category) => category.link === 'artists');
      if (artistCategory) {
        setMode(artistCategory.mode);
        setAccessDenied(false);
      } else {
        throw new Error('Artist category not found');
      }
    } catch (err) {
      setAccessDenied(true);
    }
  }, [categories]);

  // Handle delete artist
  const handleDeleteArtist = useCallback((artist) => {
    dispatch(deleteArtist(artist));
  }, [dispatch]);

  // Initialize on mount
  useEffect(() => {
    dispatch(getArtists());
    setAccess();
  }, [dispatch, setAccess]);

  // Update access when categories change
  useEffect(() => {
    setAccess();
  }, [categories, setAccess]);

  // Loading state
  if (isFetching) {
    return <PageLoader />;
  }

  // Access denied state
  if (accessDenied) {
    return <div>This category is not accessible to the logged in user.</div>;
  }

  // Prepare artist info object
  const artistsInfo = {
    deleteArtist: handleDeleteArtist,
    artists
  };

  return (
    <section className="artist-list">
      <Artists mode={mode} artistsInfo={artistsInfo} />
    </section>
  );
};

export default PiecesInstrumentContainer;
